import axios from 'axios'

function cep(cep){
    return axios.get( `https://viacep.com.br/ws/${cep}/json/`)
}

function estados(){
    return axios.get( `https://servicodados.ibge.gov.br/api/v1/localidades/estados/`)
}

function cidades(code){
    return axios.get( `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${code}/municipios`)
}

export {
    cep,
    estados,
    cidades
}
